import { useState, useEffect } from 'react';

const useIsMobile = (flag?: boolean) => {
  const [isMobile, setIsMobile] = useState(flag);

  useEffect(() => {
    const handleResize = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile ?? false;
};

export default useIsMobile;

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isTabletDevice = window.matchMedia('(max-width: 1024px)').matches;
      setIsTablet(isTabletDevice);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isTablet ?? false;
};
